// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-af89067a{to{stroke-dashoffset:0}}.main[data-v-af89067a]{display:block;min-height:50vh}[lang=zh-CN] .main[data-v-af89067a]{font-family:\"Poppins\",Helvetica,\"Noto Sans SC\",sans-serif}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
